import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export interface OrganisationProfileAttachment{
  
    id:string;
    name:string;
    path:string;
    fileObjectId:string;
    fileType:{id:string, translation:string}|null;
    course:{id:string,name:string}|null;
    member:{id:string,name:string}|null;
    uploader:{id:string,name:string};
    createdAt:Date;
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationProfileAttachmentAdapter implements Adapter<OrganisationProfileAttachment> {
  adapt(item: any): OrganisationProfileAttachment {
    return {
      id:item.id,
      fileObjectId:item.file.id,
      path:item.file.fileUrl,
      name:item.file.originalFileName,
      fileType: item.file.type,
      course: item.course? { id: item.course.id, name: item.course.name} : null,
      member: item.member? { id: item.member.id, name: item.member.userProfile.firstName + ' ' + item.member.userProfile.lastName} : null,
      uploader: { id: item.uploader.id, name: item.uploader.userProfile.firstName + ' ' + item.uploader.userProfile.lastName},
      createdAt:item.createdAt
    }
  }
}
